export function AgGridSortNumberComparator(val1: number, val2: number): number {
  try {
    return val1 - val2;
  } catch {
    return 0;
  }
}
